import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { CheckboxModel } from '../../model/checkbox.model';
import { MessageModel, MenuData, MenuCookieItem } from '../../model/menu.model';
import { menuData } from './menu.data';
import { FeedbackModel } from '../../model/feedback-model';
import { GlobalService } from '../../services/global.service';
import { StorageNames, StorageService } from 'src/app/services/storage.service';
import axios from 'axios';
import { ApiClientService } from 'src/app/services/apiClient.service';
import { RemoteDataService } from 'src/app/services/remoteData.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { PROFILES } from '../../shared/consts';
import { v4 as uuidv4 } from 'uuid';


@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {
    @Input() isHideFooter: boolean = false;
    @Input() itemsContainerHeight: string = "auto";
    @Output() closeWindow = new EventEmitter();
    @Output() menuItemsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();
    @ViewChild("closeMenuButton") closeMenuButton: ElementRef;

    expiredDate: number;
    selectedMenuItems: { [id: string]: boolean }
    refresh: string = "refresh";
    disabledIds: string[] = [];
    menuItems: MenuData[];
    enabledSettings: any;
    profileChanged = false;
    magnifyScale: string;

    public isShowStatement: boolean = false;
    public isShowFeedback: boolean = false;
    public isShowMenu: boolean;


    constructor(private globalService: GlobalService,
        private storageService: StorageService,
        private apiClient: ApiClientService,
        private remoteDataService: RemoteDataService) {

        const scale = this.storageService.get(StorageNames.MagnifyScale);
        this.magnifyScale = scale ? scale : "1";

        this.selectedMenuItems = {};
        this.menuItems = menuData;
    }

    isMobile() {
        if (this.globalService.isMobile) {
            const desktopProfiles = this.menuItems.filter(item => item.id === PROFILES.KEYBOARD || item.id === PROFILES.MAGNIFY);
            desktopProfiles.forEach(profile => profile.isShow = false);
        }
        return this.globalService.isMobile;
    }


    ngOnInit() {
        this.selectedMenuItemsFromCookies();
        this.isShowMenu = true;
    }

    ngAfterViewInit() {
        this.initilizeMenu();
    }

    initByMessage() {
        this.selectedMenuItemsFromCookies();
        this.isShowMenu = true;
        const scale = this.storageService.get(StorageNames.MagnifyScale);
        this.magnifyScale = scale ? scale : "1";
    }

    async sendStatistics(feature: string) {
        await this.apiClient.post("/statistics", {
            'visitId': uuidv4(),
            'url': window.location.href, //locally you'll need to change this to some demo url,
            // 'url': 'www.house.gov',
            'uniqueVisitId': this.storageCheckAndIsnert('uniqeVisitor'),
            'features': feature,
            'userAgent': navigator.userAgent,
            'isUnmapped': false
        });
    }

    storageCheckAndIsnert(key): string {
        const storageVal = this.storageService.get(key)
        if (storageVal) {
            return JSON.parse(storageVal)
        }
        const id = uuidv4().toString()
        this.storageService.set(key, id)

        return id
    }


    onChange($event: CheckboxModel) {
        if ($event.checked) {
            this.selectedMenuItems[$event.id] = $event.checked;
            this.sendStatistics($event.id)
            switch ($event.id) {
                case "screenReader":
                    this.selectedMenuItems["keyboardNav"] = true;
                    break;
                case "keyboardNav":
                    this.selectedMenuItems["screenReader"] = true;
                    break;
                case "contrast":
                    if (this.selectedMenuItems["grayscale"]) {
                        delete this.selectedMenuItems["grayscale"];
                    }
                    break;
                case "grayscale":
                    if (this.selectedMenuItems["contrast"]) {
                        delete this.selectedMenuItems["contrast"];
                    }
                    break;
            }
        } else {
            if ($event.id == "screenReader" || $event.id == "keyboardNav") {
                delete this.selectedMenuItems["screenReader"];
                delete this.selectedMenuItems["keyboardNav"];
            } else {
                delete this.selectedMenuItems[$event.id]
            }
        }

        this.menuItemsChanged.emit(this.getSelectedMenuItemsKeys());
        this.profileChanged = true;
        let applyBtn = document.querySelector("#applyBtn > button");
        applyBtn && applyBtn.removeAttribute("disabled");
        applyBtn && applyBtn.classList.remove("disabled");
    }

    getSelectedMenuItemsKeys() {
        return Object.keys(this.selectedMenuItems).map(item => this.menuItems.find(menu => menu.id == item).text);
    }

    getSelectedMenuItems() {
        let selectedKeys = this.getSelectedMenuItemsKeys();
        let selectedFeatures = "";
        for (let item of selectedKeys) {
            selectedFeatures += item + " ";
        }

        return selectedFeatures;
    }

    onApply() {
        let selectedItems = this.getSelectedIds();
        const hasActivatedprofiles = this.storageService.get(StorageNames.Settings);
        const data = this.multiCookieSelection(selectedItems);
        this.storageService.set(StorageNames.Settings, data);
        this.storageService.set(StorageNames.IsActive, true);

        if (!this.storageService.isLocalStorageSupported) {
            let message = {
                action: "storage",
                type: "settings",
                data
            }
            window.parent.postMessage(message, "*");
            return;
        }

        if (hasActivatedprofiles) {
            this.refreshParent();
        } else {
            (async () => {
                const {
                    accessibilityFixers,
                    globalFixers,
                    mapping,
                    localization
                } = await this.remoteDataService.getAll();
                let message = {
                    action: "settings",
                    data: {
                        settings: data,
                        localization,
                        globalFixers,
                        accessibilityFixers,
                        mapping
                    }
                }
                window.parent.postMessage(message, "*");
            })()
        }
    }

    multiCookieSelection(selectedItems: string[]) {
        let features: MenuCookieItem[] = [];
        let instructionsProfiles = [];

        for (let menuItem of selectedItems) {
            let item: MenuCookieItem = {
                id: menuItem,
                enabled: true,
            };

            switch (menuItem) {
                case "screenReader":
                    item.id = "screenReader";
                    break;
                case "keyboardNav":
                    item.id = "keyboardNav";
                    break;
                case "contrast":
                    item.id = "contrast";
                    break;
                case "grayscale":
                    item.id = "grayscale";
                    break;
                case "epilepsy":
                    item.id = "blockBlinking";
                    break;
                case "magnify":
                    item.id = "magnify";
                    item.parameters = {
                        scale: this.magnifyScale
                    }
                    break;
                case "helpLayer":
                    item.id = "helpLayer";
                    break;
            }

            features.push(item);
            this.selectedMenuItems[item.id] = true;
        }
        return {
            profiles: features,
        };
    }

    onResetAll() {
        this.selectedMenuItems = {};
        this.storageService.clearAll();
        this.refreshParent();
    }

    isEmptyObject(obj) {
        return obj && !Object.keys(obj).length;
    }

    selectedMenuItemsFromCookies() {
        let selectedItems = this.storageService.get(StorageNames.Settings);
        if (selectedItems != null) {
            selectedItems = unescape(selectedItems);
            var selected = JSON.parse(selectedItems);
            if (selected.profiles.length) {
                let selectedValues = selected.profiles;
                this.enabledSettings = selectedValues.filter(item => item.enabled);

                this.selectedMenuItems = {};
                for (let item of this.enabledSettings) {
                    switch (item.id) {
                        case "screenReader":
                        case "advancedScreenReader":
                            this.selectedMenuItems["screenReader"] = true;
                            break;
                        case "keyboardNav":
                            this.selectedMenuItems["keyboardNav"] = true;
                            break;
                        case "contrast":
                            this.selectedMenuItems["contrast"] = true;
                            this.handleColorContrastInMenu("u1st-invertCont");
                            break;
                        case "grayscale":
                            this.selectedMenuItems["grayscale"] = true;
                            this.handleColorContrastInMenu("u1st-grayscaleCont");
                            break;
                        case "blockBlinking":
                            this.selectedMenuItems["epilepsy"] = true;
                            break;
                        case "magnify":
                            this.selectedMenuItems["magnify"] = true;
                            this.magnifyScale = this.magnifyScale;
                            this.magnifyMenu();
                            break;
                        case "helpLayer":
                            this.selectedMenuItems["helpLayer"] = true;
                            break;
                        case "voiceControl":
                            this.selectedMenuItems["voiceControl"] = true;
                            break;

                    }
                }
            }
        }

        this.menuItemsChanged.emit(this.getSelectedMenuItemsKeys());
    }

    handleColorContrastInMenu(className) {
        document.getElementById("full-menu-wrapper").classList.add(className);
    }

    refreshParent() {
        let message = {
            action: "reload"
        }

        window.parent.postMessage(message, "*");
    }

    getChecked(id: string) {
        return !!this.selectedMenuItems[id];
    }

    getSelectedIds() {
        let selectedItems = [];
        for (let item of Object.keys(this.selectedMenuItems)) {
            if (this.selectedMenuItems[item]) {
                selectedItems.push(item);
            }
        }

        return selectedItems;
    }

    getFeedback($event) {
        if ($event) {
            let feedback: FeedbackModel = $event;
            feedback.langCode = this.globalService.language;
            feedback.pageUrl = this.globalService.fullUrl;
            this.apiClient.post(`/feedback`, feedback);
        }

        this.isShowFeedback = false
    }

    showFeedback($event) {
        if (!$event.keyCode || $event.keyCode === 13) {
            this.isShowFeedback = !this.isShowFeedback;
            this.isShowStatement = false;
        }
    }

    showStatement($event) {
        if (!$event.keyCode || $event.keyCode === 13) {
            this.isShowFeedback = false;
            this.isShowStatement = !this.isShowStatement;
        }
    }

    onKeydown($event) {
        if ($event.keyCode === 13) {
            setTimeout(() => {
                $event.currentTarget.click();
            }, 100)
        }
    }

    isRtl(): boolean {
        return this.globalService.isRtl();
    }

    isSpecialStyle(): boolean {
        return this.globalService.isSpecialStyle();
    }

    isMagnifyOn() {
        if (this.selectedMenuItems && this.selectedMenuItems.magnify) {
            this.magnifyMenu();
        }
    }

    magnifyMenu() {
        this.magnifyScale = this.storageService.get(StorageNames.MagnifyScale);

        if (Number(this.magnifyScale) > 1.7) this.magnifyScale = "1.7";

        const globalService = this.globalService && this.globalService;
        const body = window.document.body;

        body.style.position = 'absolute';
        body.style.bottom = '0px';

        const menuContEl = window.document.getElementById('menu-items-container');
        menuContEl && menuContEl.classList.remove('magnifyAllowScroll');

        if (globalService.isRtl()) {
            body.classList.add('magnifiedRtl');
        } else {
            body.classList.add('magnifiedLtr');
        }

        body.style.transform = `scale(${this.magnifyScale})`;
        if (Number(this.magnifyScale) >= 1.5) {
            menuContEl && menuContEl.classList.add('magnifyAllowScroll');
        }

    }

    public initilizeMenu() {
        this.isShowFeedback = false;
        this.isMagnifyOn();
        setTimeout(() => {
            this.closeMenuButton.nativeElement.focus();
        }, 100);
    }

}
